import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import DiscussionListState from 'flarum/forum/states/DiscussionListState';
app.initializers.add('val-ui-newest-sort', () => {
  override(DiscussionListState.prototype, 'sortMap', function (original) {
    const map = original();
    map.newest = '-lastPostedAt';
    return map;
  });
});